
import { Measurement, Sample, Label } from '@/lib/measurement';

export default class MeasurementRecorder {

    public measurement: Measurement;

    public constructor(exercise: string) {
        this.measurement = {
            exercise,
            timestamp: new Date(),
            samples: [],
            labels: [],
        };
    }

    public addSample(data: DataView, location: string) {
        const values = new Int16Array(data.buffer);
        const sample: Sample = {
            timestamp: new Date(),
            location,
            acceleration: {
                x: values[1] / 1000,
                y: values[2] / 1000,
                z: values[3] / 1000,
            },
            gyro: {
                x: values[4] / 10,
                y: values[5] / 10,
                z: values[6] / 10,
            },
            magneto: {
                x: values[7],
                y: values[8],
                z: values[9],
            },
        };
        this.measurement.samples.push(sample);
    }

    public addLabel(label: string) {
        this.measurement.labels.push(
            {
                timestamp: new Date(),
                label,
            },
        );
    }
}
